import { ConfigBuilder } from '@/config/ConfigBuilder';
import { ObjectProvider } from '@/config/providers/ObjectProvider';
import { JsonStorageProvider } from '@/config/providers/JsonStorageProvider';
import { defaultConfig } from '@/config/defaults';

export enum AppConfigLayer {
  WINDOW = 'window',
  LOCAL_STORAGE = 'storage',
}

export const appConfigBuilder = new ConfigBuilder(defaultConfig)
  .addLayer({ name: AppConfigLayer.WINDOW, provider: new ObjectProvider(window.config ?? {}) })
  .addLayer({
    name: AppConfigLayer.LOCAL_STORAGE,
    provider: new JsonStorageProvider({
      storageKey: 'larimar.config',
      storage: window.localStorage,
    }),
  });

export const config = appConfigBuilder.build();
